var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "like_7260745 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    transform: "translate(0.679688)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "like"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.3359 7.25V46.2188C52.3352 46.4589 52.2395 46.689 52.0697 46.8588C51.8999 47.0286 51.6698 47.1243 51.4297 47.125H6.11719C5.63692 47.1236 5.17672 46.9322 4.83712 46.5926C4.49751 46.253 4.3061 45.7928 4.30469 45.3125V7.25C4.30609 6.76973 4.4975 6.30953 4.83711 5.96992C5.17671 5.63031 5.63691 5.4389 6.11719 5.4375H50.5234C51.0037 5.4389 51.4639 5.63031 51.8035 5.96992C52.1431 6.30953 52.3345 6.76973 52.3359 7.25Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52.3359 7.25V14.5H4.30469V7.25C4.30609 6.76973 4.4975 6.30953 4.83711 5.96992C5.17671 5.63031 5.63691 5.4389 6.11719 5.4375H50.5234C51.0037 5.4389 51.4639 5.63031 51.8035 5.96992C52.1431 6.30953 52.3345 6.76973 52.3359 7.25Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4609 10.875C12.9614 10.875 13.3672 10.4693 13.3672 9.96875C13.3672 9.46824 12.9614 9.0625 12.4609 9.0625C11.9604 9.0625 11.5547 9.46824 11.5547 9.96875C11.5547 10.4693 11.9604 10.875 12.4609 10.875Z",
    fill: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.0859 10.875C16.5864 10.875 16.9922 10.4693 16.9922 9.96875C16.9922 9.46824 16.5864 9.0625 16.0859 9.0625C15.5854 9.0625 15.1797 9.46824 15.1797 9.96875C15.1797 10.4693 15.5854 10.875 16.0859 10.875Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.83594 10.875C9.33645 10.875 9.74219 10.4693 9.74219 9.96875C9.74219 9.46824 9.33645 9.0625 8.83594 9.0625C8.33543 9.0625 7.92969 9.46824 7.92969 9.96875C7.92969 10.4693 8.33543 10.875 8.83594 10.875Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M37.8359 18.125H12.4609C11.4599 18.125 10.6484 18.9365 10.6484 19.9375V32.625C10.6484 33.626 11.4599 34.4375 12.4609 34.4375H37.8359C38.837 34.4375 39.6484 33.626 39.6484 32.625V19.9375C39.6484 18.9365 38.837 18.125 37.8359 18.125Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M28.3699 25.5273L22.9324 21.9023C22.7959 21.8112 22.6373 21.759 22.4734 21.7511C22.3096 21.7431 22.1467 21.7798 22.0021 21.8572C21.8574 21.9346 21.7365 22.0498 21.6522 22.1905C21.5679 22.3313 21.5234 22.4922 21.5234 22.6563V29.9063C21.5234 30.0703 21.5679 30.2312 21.6522 30.372C21.7365 30.5127 21.8574 30.6279 22.0021 30.7053C22.1467 30.7827 22.3096 30.8194 22.4734 30.8114C22.6373 30.8035 22.7959 30.7513 22.9324 30.6603L28.3699 27.0353C28.494 26.9525 28.5958 26.8404 28.6662 26.7088C28.7366 26.5773 28.7734 26.4304 28.7734 26.2812C28.7734 26.132 28.7366 25.9851 28.6662 25.8536C28.5958 25.7221 28.494 25.61 28.3699 25.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M54.4905 41.3773C54.3205 41.1898 54.1132 41.0399 53.8818 40.9372C53.6504 40.8346 53.4001 40.7814 53.147 40.7812H48.7105L48.7109 37.1562C48.7109 36.9159 48.6154 36.6854 48.4454 36.5155C48.2755 36.3456 48.045 36.2501 47.8047 36.25H45.8289C45.4102 36.2508 45.0046 36.3962 44.6808 36.6617C44.3569 36.9271 44.1347 37.2963 44.0518 37.7067L43.4367 40.7812H42.3672V39.875C42.3672 39.6346 42.2717 39.4041 42.1018 39.2342C41.9318 39.0642 41.7013 38.9688 41.4609 38.9688H37.8359C37.5956 38.9688 37.3651 39.0642 37.1951 39.2342C37.0252 39.4041 36.9297 39.6346 36.9297 39.875V51.6562C36.9297 51.8966 37.0252 52.1271 37.1951 52.2971C37.3651 52.467 37.5956 52.5625 37.8359 52.5625H41.4609C41.7013 52.5625 41.9318 52.467 42.1018 52.2971C42.2717 52.1271 42.3672 51.8966 42.3672 51.6562V51.0045L44.866 51.6293C44.938 51.647 45.0118 51.6561 45.0859 51.6562H52.4222C52.872 51.6577 53.3062 51.4911 53.6397 51.1893C53.9732 50.8875 54.1821 50.472 54.2255 50.0243L54.9507 42.7738C54.9756 42.5218 54.9474 42.2674 54.8682 42.0269C54.7889 41.7864 54.6603 41.5652 54.4905 41.3773Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M41.4609 38.9688H37.8359C37.3354 38.9688 36.9297 39.3745 36.9297 39.875V51.6562C36.9297 52.1568 37.3354 52.5625 37.8359 52.5625H41.4609C41.9614 52.5625 42.3672 52.1568 42.3672 51.6562V39.875C42.3672 39.3745 41.9614 38.9688 41.4609 38.9688Z",
    fill: "#64B5F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.9aaf4317b981ecc75357113ba3338082.svg";
export { ForwardRef as ReactComponent };